angular.module('agreements')
    .controller('AgreementPassController', function ($scope, $rootScope, $uibModalInstance, data, Agreement, AgreementService, AgreementConst) {
        this.$onInit = () => {
            this.item = data
            this.form = {
                id: this.item.id
            }
            this.statuses = []
            if(this.item.status)
                this.statuses.push(this.item.status)

            Agreement.allowedStatuses({id: this.item.id}).$promise.then(statuses => {
                this.allowedStatuses = statuses
                this.statuses.push(...statuses.filter(s => !this.statuses.includes(s)))
            })
            // this.statuses = AgreementService.statuses()
            this.onStatusChanged(this.item.status)
        }
        this.onStatusChanged = (newStatus) => {
            this.form.status = newStatus
            delete this.form.worker
            if(this.isStatusFinishedOrArchived()){
                this.users = []
            }
        }
        this.isStatusFinishedOrArchived = () => {
            // return ['ARCHIVED'].includes(this.form.status)
            return false
        }
        this.isCommentRequired = () => {
            return ['REJECTED', 'STOPPED'].includes(this.form.status)
        }
        this.toggleAllStatuses = () => {
            Agreement.allStatuses({id: this.item.id}).$promise.then(statuses => {
                this.statuses = statuses
            })
        }
        this.cancel = () => $uibModalInstance.dismiss('Canceled')
        this.save = () => {
            return Agreement.pass(this.form).$promise
                .then(() => {
                    $uibModalInstance.close()
                    $rootScope.$broadcast(AgreementConst.eventUpdate)
                })
        }
    })
